import { Fragment } from "react";

const Portfolio = () => {
  return (
    <Fragment>
      <video autoPlay loop muted id="video" className="fixed w-full h-full">
        <source src={process.env.PUBLIC_URL + "/videos/particlesBall.mp4"} />
      </video>
      <div className="content-list">
        <div className={"post"}>
          <div className="post-content">
            <h2 className="post-title">Coming soon...</h2>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Portfolio;
